// Общий кэш-ключ flagged-звеньев — используется и панелью модерации, и бейджем в SpiteGame
// (React Query дедуплицирует запрос по одинаковому ключу).
export const CHALLENGE_FLAGGED_KEY = (smenaId) => ['neighbor', 'challenges-flagged', smenaId];

export const CHALLENGE_CHAINS_KEY = (taskId) => ['neighbor', 'challenge-chains', taskId];
